export default {"src":"/_next/static/media/rightarrow.35ef208e.svg","height":66,"width":66,"blurWidth":0,"blurHeight":0};